export default "__VITE_PUBLIC_ASSET__8390dff1__"